import axiosClient from "../../../../../../axiosClient"

export default async (id, { summary = false } = {}) => {
    const result = await axiosClient.get(`/pre-check-geolocation/${id}`, {
        // summary: header-only data — no secure DB read / decryption on the backend.
        params: summary ? { summary: 1 } : undefined,
    })
    return result.data
}
